<template>
    <div>
      <img :src="slide.image" alt="">
    </div>
</template>

<script>
    export default {
        name: "tBanner",
        data() {
            return {
                slide: [],
            }
        },
        mounted: function () {
            this.getSlideList();
        },
        methods: {
            getSlideList: async function() {
                let res = await this.$getJSON('index/getSlideList',{cat_id:2});
                if (res.code == 1) {
                    let slideList= res.data.slideList;
                    this.slide = slideList[0];
                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/banner.vue